import app from '$$app';
import ganttViewModel from '$$ganttViewModel';
import plansModel from '../../models/plans';
// import { sendToExport } from '../../components/Export';
import projectsModel from '$$projectModel';
import ExcelExporter from './ExcelExporter';

class GanttExporter {
  constructor(ganttInstance, { exportType, exportSettings }) {
    this.ganttInstance = ganttInstance;
    this.exportSettings = exportSettings;
    this.exportType = exportType;
  }

  export() {
    switch (this.exportType) {
    case 'pdf':
    case 'png':
      this.exportPDF();
      break;
    case 'xml':
      this.exportXML();
      break;
    case 'xlsx':
      (new ExcelExporter(this.ganttInstance, this.exportSettings)).export();
      break;
    default:
      throw Error('Unexpected export type');
    }
  }

  exportPDF() {
    const exportProject = this.preparePdfExportData();

    this.setGanttSizes(`${exportProject.config.ganttDataAreaWidth}px`, `${exportProject.config.ganttDataAreaHeight}px`);
    const html = this.getGanttHTMLString();

    fetch('/api/export', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ exportType: 'project', exportProject, html, socketId: app.socket.id }),
    });
    this.setGanttSizes('100%', '100%');
  }

  exportXML() {
    const exportOptions = this.prepareXmlExportData();

    this.ganttInstance.exportToXML(exportOptions);
  }

  setGanttSizes(width, height) {
    const ganttView = this.ganttInstance.$layout.$container;

    ganttView.style.width = width;
    ganttView.style.height = height;
    // need for repaint
    this.ganttInstance.setSizes();
  }

  getGanttHTMLString() {
    const ganttWrapper = this.ganttInstance.$layout.$container.closest('.gantt_skin_terrace');
    const svgIcons = document.querySelector('#svg-sprite-wrap');
    const styles = document.querySelectorAll('style[id^="gantt-static-bg-styles"]');
    const stylesHTML = Array.from(styles).reduce((res, item) => res + item.outerHTML, '');

    return ganttWrapper.outerHTML + svgIcons.outerHTML + stylesHTML;
  }

  calculateGanttDataAreaDimensions() {
    const ganttDataArea = document.querySelector('.gantt_data_area');
    const ganttGrid = document.querySelector('.gantt_grid');
    const workloadBody = document.querySelector('.workload-body');
    const visibleTasks = this.ganttInstance.serialize().data.filter(task => this.ganttInstance.isTaskVisible(task.id));
    const ganttDataAreaWidth = ganttDataArea.offsetWidth + ganttGrid.offsetWidth;
    let ganttDataAreaHeight = visibleTasks.length * this.ganttInstance.config.row_height + 200;

    if (workloadBody) {
      ganttDataAreaHeight += workloadBody.offsetHeight;
    }

    return {
      ganttDataAreaWidth,
      ganttDataAreaHeight,
    };
  }

  preparePdfExportData() {
    const viewData = ganttViewModel.getActiveViewData();

    return {
      ganttId: this.ganttInstance.config.gantt_id,
      multiviewId: this.ganttInstance.config.multiview_id,
      viewName: viewData.name,
      skin: viewData.config.userSkin,
      teamName: user.team.name,
      userId: user.id,
      lang: window.langByProduct?.app?.lang,
      config: {
        ...this.calculateGanttDataAreaDimensions(),
        viewSize: this.exportSettings.paperSize,
        isLandscape: this.exportSettings.orientation === 'landscape',
        format: this.exportType,
        isTrial: plansModel.isTrial(),
        teamLogo: user.team.logo,
        favicon: user.team.favicon,
        teamName: user.team.name,
        show_favicon: user.team.show_favicon,
      },
    };
  }

  prepareXmlExportData() {
    const projectData = projectsModel.getActiveProjectData();

    return {
      name: `${encodeURIComponent(projectData.name)}.xml`,
      title: encodeURIComponent(projectData.name),
      time: this.ganttInstance.config.worktimes.global,
      tasks: {
        Work(task) {
          return task.estimation;
        },
      },

    };
  }
}

export default GanttExporter;
